import Google from '../data/google-play-badge.png'
import Apple from '../data/Apple.svg'
import React from 'react';


export default function Mobile(){
    return(
        <div style={{ backgroundColor: "rgb(103, 212, 239)", minHeight: "100vh", textAlign: "center" }}>
            <div style={{ paddingTop: "10vh" }}>
              <img alt="moving crown" style={{ width: "100px", marginBottom: "0px" }} src={'https://media2.giphy.com/media/WrOWmtynf0D9ieZ3B4/giphy.gif?cid=19f5b51ae8aad48dd8616f2b71289389985c878eef5418ac&rid=giphy.gif'} />
              <br></br>
              <img alt="mobile animation" style={{ width: "100px", marginTop: "0px" }} src={'https://media0.giphy.com/media/idG99i57u1Jy0x5fcd/giphy.gif?cid=6c09b952f21ad89bb7658452d72f98a2be6117e0c16410ff&rid=giphy.gif'} />

              <p style={{ fontWeight: "normal" }}>Get imagi app for your phone!</p>

              <a href="https://bit.ly/3iGkbAG"><img alt="Google Play" style={{ width: "250px" }} src={Google} /></a>
              <br></br>
              <a href="https://apps.apple.com/us/app/imagilabs/id1434239482"> <img alt="App store" style={{ width: "220px" }} src={Apple} /></a>

            </div>
          </div>

    )
}